import AmexCarouselEditorialCard from './AmexCarouselEditorialCard';

export default AmexCarouselEditorialCard;
